import { render, staticRenderFns } from "./NonCompliantProductTableComponent.vue?vue&type=template&id=1a636dcf"
import script from "./NonCompliantProductTableComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports